<div class="px-4">
    <div class="d-flex align-items-center">
        <h5
            class="flex-grow-1 text-center mt-5 mb-4 ms-5"
            [textContent]="title | translateTokenisedString"
        ></h5>

        <button type="button" wdxIconButton (click)="onClose()">
            <wdx-icon [icon]="ICON_CLOSE"></wdx-icon>
        </button>
    </div>
    <div
        class="pb-2 text-center"
        [innerHTML]="description | translateTokenisedString"
    ></div>
    @if (showErrorDetails) {
        @if (showJson) {
            <div class="border rounded">
                <div
                    class="d-flex justify-content-between bg-light border-bottom p-3"
                >
                    <span>{{
                        'ERROR_MODAL_JSON_TITLE' | translateTokenisedString
                    }}</span>
                </div>

                <div class="p-4 json-content overflow-auto">
                    <pre>{{ jsonData | json }}</pre>
                </div>
            </div>
        }
    }
    <div
        class="dialog-footer d-flex align-items-center justify-content-center mt-4 mb-5"
    >
        @if (showErrorDetails) {
            @if (!showJson) {
                <button
                    wdxButton
                    [wdxButton]="WDX_BUTTON_STYLE.Primary"
                    (click)="showJsonError()"
                >
                    {{ 'BTN_SHOW_MORE' | translateTokenisedString }}
                </button>
            } @else {
                <div class="d-flex justify-content-center gap-2">
                    <button
                        wdxButton
                        [wdxButton]="WDX_BUTTON_STYLE.Primary"
                        [ngbPopover]="
                            'ERROR_MODAL_POPOVER' | translateTokenisedString
                        "
                        #popover="ngbPopover"
                        (click)="copyJson(popover)"
                    >
                        {{ 'ERROR_MODAL_COPY' | translateTokenisedString }}
                        <wdx-icon [icon]="ICON_COPY"></wdx-icon>
                    </button>
                    <button
                        wdxButton
                        [wdxButton]="WDX_BUTTON_STYLE.Primary"
                        (click)="downloadJson()"
                    >
                        {{ 'ERROR_MODAL_DOWNLOAD' | translateTokenisedString }}
                        <wdx-icon [icon]="ICON_DOWNLOAD"></wdx-icon>
                    </button>
                </div>
            }
        }
    </div>
</div>
